import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SourceImageDirective } from '@celerofinancas/ui-directives';

/**
 * Generic empty/error state placeholder: a centered illustration plus a short
 * message. Mirrors the look used by the shared data-table so empty sections
 * (e.g. "Faturas do cartão", "Gastos totais por categoria") stay visually
 * consistent across the credit card summary screen instead of rendering blank.
 */
@Component({
  selector: 'caixa-webcomponent-empty-state',
  standalone: true,
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SourceImageDirective],
})
export class EmptyStateComponent {
  /**
   * Message shown below the illustration.
   */
  @Input()
  public message = '';

  /**
   * Illustration source as a THEME-LESS base path (no `light`/`dark` segment).
   * `cdsSource` (SourceImageDirective) injects the current theme segment at
   * runtime — e.g. `assets/common/shared/no-content.svg` resolves to
   * `assets/common/light/shared/no-content.svg` or `.../dark/...`.
   */
  @Input()
  public image = 'assets/common/shared/no-content.svg';

  /**
   * Image alt text. Falls back to `message` when not provided.
   */
  @Input()
  public alt = '';
}
